import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import FacilitiesManager from './components/FacilitiesManager';
import CSVUploadManager from './components/CSVUploadManager';
import Settings from './components/Settings';
import InspectionReportsDashboard from './components/InspectionReportsDashboard';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/') return 'dashboard';
    if (path === '/facilities') return 'facilities';
    if (path === '/csv-upload') return 'csv-upload';
    if (path === '/inspection-reports') return 'inspection-reports';
    if (path === '/settings') return 'settings';
    return 'dashboard';
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Routes>
      {/* Standalone route without Layout */}
      <Route path="/inspection-reports" element={<InspectionReportsDashboard />} />

      {/* Routes with Layout */}
      <Route path="*" element={
        <Layout currentPage={getCurrentPage()} onNavigate={handleNavigate}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/facilities" element={<FacilitiesManager />} />
            <Route path="/csv-upload" element={<CSVUploadManager />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
